import factory from './factory'

export default {
  filterByBank (state, value) {
    if (value === null) {
      state.filtered = factory.clearBankFilter().filtered
    } else {
      state.filtered = factory.filterByBank(value).filtered
    }
    state.appliedFilters = factory.appliedFilters
  },
  filterByCategory (state, value) {
    if (value === null) {
      state.filtered = factory.clearCategoryFilter().filtered
    } else {
      state.filtered = factory.filterByCategory(value).filtered
    }
    state.appliedFilters = factory.appliedFilters
  },
  filterByCountry (state, value) {
    if (value === null) {
      state.filtered = factory.clearCountryFilter().filtered
    } else {
      state.filtered = factory.filterByCountry(value).filtered
    }
    state.appliedFilters = factory.appliedFilters
  }
}
